/**
 * @fileoverview The i18next namespace `@puffin-core/captcha-ui` registers under.
 * @package @puffin-core/captcha-ui
 *
 * Its own module so `useCaptchaTranslate` and the registrar can both import the
 * constant without either importing the other's module graph — the same split
 * `@puffin-core/login-shell` uses for `LOGIN_NAMESPACE`.
 */

export const CAPTCHA_NAMESPACE = 'captcha';

export default CAPTCHA_NAMESPACE;
